// Footer partilhado (login/registo) — réplica do rodapé de ihavethepower.net.
export const SiteFooter = () => {
  return (
    <footer
      data-testid="site-footer"
      className="w-full bg-[#0F1829] text-white/80"
      style={{ fontFamily: "'Manrope', sans-serif" }}
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-10 py-8 flex flex-col sm:flex-row items-center sm:items-center justify-between gap-6">
        <img
          src="/logo-ihtp.svg"
          alt="I Have the Power"
          className="h-9 w-auto"
          data-testid="footer-logo"
        />
        <div className="text-center sm:text-right text-xs sm:text-sm leading-tight text-white/70">
          <p data-testid="footer-copyright" className="m-0">© SOLFUT LDA. | Todos os direitos reservados.</p>
          <p data-testid="footer-credit" className="m-0 mt-1">Web Design by Rafaela Vieira x Unlimited Studio</p>
        </div>
      </div>
    </footer>
  );
};

export default SiteFooter;
